import Vue from "vue"
import router from "@/config/router"
import http from "@/config/http"

// @ts-ignore
import auth from "@websanova/vue-auth/dist/v2/vue-auth.esm.js"
// @ts-ignore
import driverAuthBearer from "@websanova/vue-auth/src/drivers/auth/bearer.js"
// @ts-ignore
import driverHttpAxios from "@websanova/vue-auth/src/drivers/http/axios.1.x.js"
// @ts-ignore
import driverRouterVueRouter from "@websanova/vue-auth/src/drivers/router/vue-router.2.x.js"
// @ts-ignore
import driverOAuth2Google from "@websanova/vue-auth/src/drivers/oauth2/google.js"
// @ts-ignore
import driverOAuth2Facebook from "@websanova/vue-auth/src/drivers/oauth2/facebook.js"

driverOAuth2Google.params.client_id =
    "547886745924-4vrbhl09fr3t771drtupacct6f788566.apps.googleusercontent.com"
driverOAuth2Facebook.params.client_id = "196729390739201"

Vue.use(auth, {
    plugins: {
        http: http,
        router: router,
    },
    drivers: {
        auth: driverAuthBearer,
        http: driverHttpAxios,
        router: driverRouterVueRouter,
        oauth2: {
            google: driverOAuth2Google,
            facebook: driverOAuth2Facebook,
        },
    },
    options: {
        registerData: {
            redirect: null,
        },
        authRedirect: {
            path: "/auth/login",
        },
        rolesKey: "type",
        notFoundRedirect: { path: "/" },
        stores: ["cookie", "storage"],
        parseUserData({ data }: any) {
            return data.user
        },
    },
})
